import React, { useState } from 'react';
import { NotificationBell } from '../../icons/NotificationBell';
import {
  NotificationsBellContainer,
  NotificationsCounter,
} from './NotificationsBell.styled';
import { useNavigate } from 'react-router-dom';
import UnsavedFormDataModal from '../../../../components/commons/UnsavedFormDataModal';
import { getItem } from '../../../../utils/localStorage';
export interface INotificationBell {
  notificationsCount: number;
}

export function NotificationsBell ({ notificationsCount }: INotificationBell) {
  const navigate = useNavigate();
  const [showUnsavedDataModal, setShowUnsavedDataModal] =
    useState<boolean>(false);

  const MAX_NOTIFICATIONS = 99;
  const notificationsCountToDisplay =
    notificationsCount > MAX_NOTIFICATIONS
      ? `${MAX_NOTIFICATIONS}+`
      : notificationsCount;

  return (
    <>
      <NotificationsBellContainer
        data-testid="notifications-bell"
        onClick={() => {
          if (getItem('isFormData')) {
            setShowUnsavedDataModal(true);
            return;
          }
          navigate('/notifications');
        }}
      >
        <NotificationBell size={28} />
        {notificationsCount > 0 && (
          <NotificationsCounter data-testid="notifications-bell-counter">
            {notificationsCountToDisplay}
          </NotificationsCounter>
        )}
      </NotificationsBellContainer>
      {showUnsavedDataModal && (
        <UnsavedFormDataModal
          data-testid="unsaved-data-modal"
          showUnsavedDataModal={showUnsavedDataModal}
          setShowUnsavedDataModal={setShowUnsavedDataModal}
          onContinue={() => navigate('/notifications')}
        />
      )}
    </>
  );
}
